/**
 * The sidebar's information architecture (2026-09 redesign): grouped by
 * what a site manager comes to DO, not by internal module.
 *
 *   operations — watch the site now      (home, live, alerts)
 *   proof      — prove it to an insurer  (risk surveyor, compliance, logbook, reports)
 *   site       — people and places       (workers, vehicles, cameras, zones)
 *   system     — pinned to the bottom     (AI hub, settings, help)
 *
 * Every route that existed before is still here; nothing was dropped.
 * `key` is both the `nav.<key>` label and the `NAV_ICON_MAP` icon.
 */
export interface NavItem {
  to: string;
  key: string;
  adminOnly?: boolean;
}

export interface NavGroup {
  key: "operations" | "proof" | "site" | "system";
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    key: "operations",
    items: [
      { to: "/dashboard", key: "dashboard" },
      { to: "/monitor", key: "monitor" },
      { to: "/alerts", key: "alerts" },
    ],
  },
  {
    key: "proof",
    items: [
      { to: "/ai-inspector", key: "aiInspector" },
      { to: "/compliance", key: "compliance" },
      { to: "/pinkas", key: "pinkas" },
      { to: "/reports", key: "reports" },
    ],
  },
  {
    key: "site",
    items: [
      { to: "/workers", key: "workers" },
      { to: "/vehicles", key: "vehicles" },
      { to: "/cameras", key: "cameras" },
      { to: "/zones", key: "zones" },
    ],
  },
  {
    key: "system",
    items: [
      { to: "/ai", key: "aiHub", adminOnly: true },
      { to: "/settings", key: "settings" },
      { to: "/help", key: "help" },
    ],
  },
];
